import React from "react";
import { useSelector } from "react-redux";
import LoginHeader from "../Login/LoginHeader";

const SupplierDashboard = () => {
  const { isAuthenticated} = useSelector((state) => state.auth);

  return (
    <>
    <LoginHeader isAuthenticated={isAuthenticated}/>
    <div className="flex justify-center items-center text-2xl font-bold h-[100vh]">
      <h2>Welcome to the supplier profile</h2>
    </div>
    </>
  );
};

export default SupplierDashboard;